// extracted by mini-css-extract-plugin
export default {"good":"Statistics_good__Ityhd","neutral":"Statistics_neutral__wS3yD","bad":"Statistics_bad__xcvkP","positiveFeedback":"Statistics_positiveFeedback__lXAf+"};